import { t } from '@lingui/core/macro';
import { Menu, pxToRem } from '@pocketlaw/tetris';
import { SidebarMenuFooter, SidebarMenuUser } from 'app/domains/common-ui';
import { UserAccountMenu } from 'app/domains/users';
import { useMobile } from 'shared/domains/common-ui';
import { useAccount } from 'shared/domains/users';
export function Footer() {
    var _a, _b;
    const { data: accountData } = useAccount();
    const isMobile = useMobile();
    const userName = ((_a = accountData.profile) === null || _a === void 0 ? void 0 : _a.name) || '';
    const companyName = ((_b = accountData.company) === null || _b === void 0 ? void 0 : _b.name) || '';
    const minimizedTooltip = t({
        comment: 'Sidebar menu - User settings tooltip label',
        message: 'User settings',
    });
    return (<SidebarMenuFooter>
      <Menu.Root side={isMobile ? 'top' : 'right'} minWidth={pxToRem(300)} maxWidth={pxToRem(400)} target={<div>
            <SidebarMenuUser userName={userName} companyName={companyName} minimizedTooltip={minimizedTooltip}/>
          </div>}>
        <UserAccountMenu />
      </Menu.Root>
    </SidebarMenuFooter>);
}
